import React, { useState, useEffect } from "react";
import Layout from "../../layout/Layout";
import { Form } from "react-bootstrap";
import MyEditor from "../../components/MyEditor";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../utils/axiosConfig";
import * as CustomToast from "../../components/CustomToastMessage";
import BlogImageUpload from "../../components/blogImageUpload";

function BlogsEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    content: "",
    creditSource: "",
    // blogImage: null,
    phoneImage: null,
    notificationType: false,
    publishOn: "both",
    metaTitle: "",
    metaDescription: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/admin/blog/${id}`
        );
        const blog = response.data.data;
        setFormData({
          title: blog.title,
          slug: blog.slug,
          content: blog.content,
          creditSource: blog.creditSource || "",
          // blogImage: blog.blogImage || null,
          phoneImage: blog?.phoneImage || blog?.blogImage || null,
          notificationType:
            typeof blog?.notificationType === "boolean"
              ? blog.notificationType
              : false,
          publishOn: blog.publishOn,
          metaTitle: blog.meta?.title || "",
          metaDescription: blog.meta?.description || "",
        });
      } catch (error) {
        console.error(error.response.data.message);
        navigate("/blogs");
      }
    };
    if (id) fetchBlog();
  }, [id, navigate]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditorChange = (content) => {
    setFormData((prev) => ({
      ...prev,
      content: content,
    }));
  };
  const handleNotificationChange = (e) => {
    setFormData({
      ...formData,
      notificationType: e.target.checked,
    });
  };
  const handlePublishChange = (e) => {
    setFormData({
      ...formData,
      publishOn: e.target.value,
    });
  };

  const handleImageUpload = (file) => {
    setFormData((prev) => ({ ...prev, blogImage: file }));
  };
  const handleImagePhoneImageUpload = (file) => {
    setFormData((prev) => ({ ...prev, phoneImage: file }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!formData?.blogImage) {
    //   CustomToast.error("Please select a recipe image for desktop");
    //   return;
    // }
    if (!formData?.phoneImage) {
      CustomToast.error("Please select a recipe image for mobile");
      return;
    }
    if (!formData?.title) {
      CustomToast.error("Please enter a recipe title");
      return;
    }
    if (!formData?.slug) {
      CustomToast.error("Please enter a recipe slug");
      return;
    }
    if (!formData?.metaTitle) {
      CustomToast.error("Please enter a meta title");
      return;
    }
    if (!formData?.metaDescription) {
      CustomToast.error("Please enter a meta description");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("slug", formData.slug);
    formDataToSend.append("content", formData.content);
    formDataToSend.append("creditSource", formData.creditSource);
    formDataToSend.append(
      "notificationType",
      Boolean(formData.notificationType)
    );
    formDataToSend.append("publishOn", formData.publishOn);
    formDataToSend.append(
      "meta",
      JSON.stringify({
        title: formData.metaTitle,
        description: formData.metaDescription,
      })
    );
    // if (formData?.blogImage) {
    //   formDataToSend.append("blogImage", formData.blogImage);
    // }
    if (formData?.phoneImage) {
      formDataToSend.append("phoneImage", formData.phoneImage);
    }
    setLoading(true);
    try {
      await axiosInstance.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/blog/edit/${id}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      CustomToast.success("Blog updated successfully");
      navigate("/blogs");
    } catch (error) {
      if (error.response.data.status === 400) {
        CustomToast.error(error.response?.data?.message);
      }
      console.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="Edit Recipe Blog">
      <main>
        <div className="card page-card">
          <div className="card-body">
            <div className="row g-3">
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <Form.Group controlId="mobileImageUpload">
                    {/* <Form.Label>Recipe Image(Mobile)</Form.Label> */}
                    <Form.Label>Recipe Image</Form.Label>
                    <BlogImageUpload
                      // imageMaxHeight={250}
                      // imageMaxWidth={337}
                      imageMaxHeight={420}
                      imageMaxWidth={530}
                      onFileSelect={(file) => {
                        handleImagePhoneImageUpload(file);
                      }}
                      initialImage={formData.phoneImage}
                      name="phoneImage"
                    />
                    {/* <p className="my-1">
                      <span className="fw-semibold">Note : </span>Resolution
                      530x420 (Width x Height)
                    </p> */}
                    {/* <p className="my-1">
                      <span className="fw-semibold">Note : </span>Resolution
                      337x250 (Width x Height)
                    </p> */}

                    {/* <p className="fw-500">Note: Max file size 1mb and resolution 182x200</p> */}
                  </Form.Group>
                </div>
              </div>
              <div className="col-12">
                <Form.Group controlId="email">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    placeholder="Enter recipe title"
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group controlId="email">
                  <Form.Label>Slug</Form.Label>
                  <Form.Control
                    type="text"
                    name="slug"
                    value={formData.slug}
                    onChange={handleInputChange}
                    placeholder="Enter recipe slug"
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group controlId="CreditSource">
                  <Form.Label>Credit Source</Form.Label>
                </Form.Group>
                <input
                  className="form-control"
                  name="creditSource"
                  value={formData.creditSource}
                  onChange={handleInputChange}
                  placeholder="Enter credit source"
                />
              </div>
              <div className="col-12">
                <Form.Group controlId="Password">
                  <Form.Label>Content</Form.Label>
                </Form.Group>
                <MyEditor
                  htmlData={formData.content}
                  setCourseAdd={(content) => {
                    handleEditorChange(content);
                  }}
                />
              </div>
              <div className="col-3">
                <Form.Group controlId="notificationOptions">
                  <Form.Label>Publish On:</Form.Label>
                  <div>
                    <Form.Check
                      inline
                      label="Mobile"
                      name="publishOn"
                      type="radio"
                      id="mobile"
                      value="mobile"
                      onChange={handlePublishChange}
                      checked={String(formData.publishOn) === "mobile"}
                    />
                    <Form.Check
                      inline
                      label="Web"
                      name="publishOn"
                      type="radio"
                      id="web"
                      value="web"
                      onChange={handlePublishChange}
                      checked={String(formData.publishOn) === "web"}
                    />
                    <Form.Check
                      inline
                      label="Both"
                      name="publishOn"
                      type="radio"
                      id="both"
                      value="both"
                      onChange={handlePublishChange}
                      checked={String(formData.publishOn) === "both"}
                    />
                  </div>
                </Form.Group>
              </div>
              <div className="col-4">
                <Form.Group controlId="notificationOptions">
                  <Form.Label> Would you like to notify the user?</Form.Label>
                  <div>
                    <Form.Check
                      className="custom-switch d-flex align-items-center gap-2"
                      type="switch"
                      id="notification-switch"
                      label="Yes, send notification"
                      checked={formData.notificationType}
                      onChange={handleNotificationChange}
                    />
                  </div>
                </Form.Group>
              </div>

              <div className="col-12">
                <Form.Group controlId="MetaTitle">
                  <Form.Label>Meta Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="metaTitle"
                    value={formData.metaTitle}
                    onChange={handleInputChange}
                    placeholder="Enter meta title"
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group controlId="MetaDescription">
                  <Form.Label>Meta Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="metaDescription"
                    value={formData.metaDescription}
                    onChange={handleInputChange}
                    placeholder="Enter meta description"
                  />
                </Form.Group>
              </div>
              <div className="col-12 d-flex justify-content-end gap-3">
                <button
                  className="btn-outline fs-16 fw-700 px-4"
                  onClick={() => navigate("/blogs")}
                  type="button"
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  className="btn-primary fs-16 fw-700 px-4"
                  onClick={handleSubmit}
                  type="button"
                  disabled={loading}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default BlogsEdit;

// {false && (
//   <div className="col-12 col-md-6">
//     <Form.Group controlId="email">
//       <Form.Label>Recipe Image(Desktop)</Form.Label>
//       <BlogImageUpload
//         // imageMaxHeight={500}
//         // imageMaxWidth={455}
//         imageMaxHeight={420}
//         imageMaxWidth={530}
//         onFileSelect={handleImageUpload}
//         initialImage={formData.blogImage}
//         name="blogImage"
//       />
//       <p className="my-1">
//         <span className="fw-semibold">Note : </span>Resolution
//         530x420 (Width x Height)
//         {/* 455x500 (Width x Height) */}
//       </p>
//       {/* <p className="fw-500">Note: Max file size 1mb and resolution 182x200</p> */}
//     </Form.Group>
//   </div>
// )}
